/** 模拟与渲染共享的常量。改动这里的任何值都必须递增 SIM_VERSION。 */

export const SIM_VERSION = 6;

/** 模拟频率：20 Hz。RTS 不需要格斗游戏的响应精度，20 Hz 把计算量降到 60 Hz 的 1/3。 */
export const TICKS_PER_SEC = 20;
export const MS_PER_TICK = 1000 / TICKS_PER_SEC;

/** 实体上限。双方满人口 + 中立生物 + 建筑 + 投射物的极端情况。 */
export const MAX_ENTITIES = 4096;

/** 地图尺寸（格） */
export const MAP_W = 96;
export const MAP_H = 96;

/** 人口上限 */
export const POP_CAP = 100;

/** 玩家槽位 */
export const PLAYER_HUMAN = 0;
export const PLAYER_AI = 1;
export const PLAYER_COUNT = 2;

/** 护甲类型 */
export const enum Armor {
  Unarmored = 0,
  Light = 1,
  Heavy = 2,
  Structure = 3,
  Anomalous = 4,
}

/** 伤害类型 */
export const enum Damage {
  Kinetic = 0,
  AP = 1,
  Explosive = 2,
  Incendiary = 3,
  Psionic = 4,
  Lawful = 5,
}

/** 实体分类 */
export const enum Kind {
  Infantry = 0,
  Vehicle = 1,
  Building = 2,
  Harvester = 3,
  Projectile = 4,
}

/** 单位当前行为 */
export const enum Order {
  Idle = 0,
  Move = 1,
  AttackMove = 2,
  Attack = 3,
  Harvest = 4,
  ReturnCargo = 5,
  Build = 6,
}

/** 渲染快照里每个实体占用的 int32 槽位数 */
export const SNAP_STRIDE = 12;
export const enum Snap {
  Id = 0,
  X = 1,
  Y = 2,
  Kind = 3,
  Owner = 4,
  TypeId = 5,
  Hp = 6,
  MaxHp = 7,
  DirX = 8,
  DirY = 9,
  Flags = 10,
  Progress = 11,
}

export const enum SnapFlag {
  Selected = 1 << 0,
  Firing = 1 << 1,
  Constructing = 1 << 2,
  LowPower = 1 << 3,
  Cargo = 1 << 4,
}

/** 战争迷雾格状态 */
export const enum Fog {
  Unseen = 0,
  Explored = 1,
  Visible = 2,
}
